module.exports = __webpack_public_path__ + "img/6.b8664482.jpg";